import { DefaultSet } from "../../utils/constant";
import {
  FETCH_SENTIMENT_REQUEST,
  FETCH_SENTIMENT_SUCCESS,
  FETCH_SENTIMENT_FAILURE,
  CREATE_SENTIMENT_REQUEST,
  CREATE_SENTIMENT_SUCCESS,
  CREATE_SENTIMENT_FAILURE,
  UPDATE_SENTIMENT_REQUEST,
  UPDATE_SENTIMENT_SUCCESS,
  UPDATE_SENTIMENT_FAILURE,
  DELETE_SENTIMENT_REQUEST,
  DELETE_SENTIMENT_SUCCESS,
  DELETE_SENTIMENT_FAILURE,
  FETCH_USERSET_REQUEST,
  FETCH_USERSET_SUCCESS,
  FETCH_USERSET_FAILURE,
  CREATE_USERSET_REQUEST,
  CREATE_USERSET_SUCCESS,
  CREATE_USERSET_FAILURE,
  UPDATE_USERSET_REQUEST,
  UPDATE_USERSET_SUCCESS,
  UPDATE_USERSET_FAILURE,
  DELETE_USERSET_REQUEST,
  DELETE_USERSET_SUCCESS,
  DELETE_USERSET_FAILURE,
  SET_USERSET,
  SET_METRIC_SETTING_ID,
} from "../constants/actionTypes";

const initialState = {
  loading: false,
  data: [],
  metricSettingId:DefaultSet,
  brandAuditMetricSettingId:DefaultSet,
  error: null,
  deleteLoading: false,
  showModel: false,
  brandAuditMetricSettingId: "default"
};

const userSetReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SENTIMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_SENTIMENT_REQUEST:
    case UPDATE_SENTIMENT_REQUEST:
      // case DELETE_SENTIMENT_REQUEST:
      return {
        ...state,
        loading: true,
        // deleteLoading: true,
      };
    case DELETE_SENTIMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SENTIMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          sentiment: action.payload,
        },
      };
    case CREATE_SENTIMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: [...state.data, action.payload],
      };
    case UPDATE_SENTIMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: state.data.map((brand) =>
        //   brand.id === action.payload.id ? action.payload : brand
        // ),
      };
    case DELETE_SENTIMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // data: state.data.data.filter(brand => brand.id !== action.payload),
      };
    case FETCH_SENTIMENT_FAILURE:
    case CREATE_SENTIMENT_FAILURE:
    case UPDATE_SENTIMENT_FAILURE:
    case DELETE_SENTIMENT_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // error: action.error,
      };
    case FETCH_USERSET_REQUEST:
      return {
        ...state,
        loading: true,
      };
       case SET_USERSET:
      return {
        ...state,
        loading: false,
        data:action.payload,
        metricSettingId:"default"
      };
         case SET_METRIC_SETTING_ID:
      return {
        ...state,
        loading: false,
        metricSettingId:action.payload
      };
    case CREATE_USERSET_REQUEST:
    case UPDATE_USERSET_REQUEST:
      // case DELETE_USERSET_REQUEST:
      return {
        ...state,
        loading: true,
        // deleteLoading: true,
      };
    case DELETE_USERSET_REQUEST:
      return {
        ...state,
        // loading: true,
        deleteLoading: true,
      };
    case FETCH_USERSET_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case CREATE_USERSET_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: [...state.data, action.payload],
      };
    case UPDATE_USERSET_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: state.data.map((brand) =>
        //   brand.id === action.payload.id ? action.payload : brand
        // ),
      };
    case DELETE_USERSET_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // data: state.data.data.filter(brand => brand.id !== action.payload),
      };
    case FETCH_USERSET_FAILURE:
    case CREATE_USERSET_FAILURE:
    case UPDATE_USERSET_FAILURE:
    case DELETE_USERSET_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // error: action.error,
      };


    case "RESET_METRIC":
      return {
        ...initialState,
      };
    case "SET_METRICE_SETTING_ID":
      return {
        ...state,
        metricSettingId: action.payload,
      };
       case "SET_BRAND_AUDIT_METRICE_SETTING_ID":
      return {
        ...state,
        brandAuditMetricSettingId: action.payload,
      };

    case "HANDLE_ATTRIBUTE_DELETE":
      let updatedState = sentimentQuestionRemove({ state, ...action.payload });
      return {
        ...updatedState,
      };

    case "HANDLE_ATTRIBUTE_CREATE":
      let updated = attributeAdd({ state, ...action.payload });
      return {
        ...updated,
      };

    case "HANDLE_ATTRIBUTE_UPDATE":
      let updatedAttr = attributeUpdate({ state, ...action.payload });
      return {
        ...updatedAttr,
      };
    case "ACTION_MODEL":
      return {
        ...state,
        showModel: action.payload,
      };
    case "REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FAILED":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default userSetReducer;

function sentimentQuestionRemove({
  state,
  id,
  selectedSideTab,
  type = "sentiment",
}) {
  let updatedData = state.data.map((set) =>
    selectedSideTab == set.id
      ? { ...set, [type]: set[type].filter((ele) => ele.id != id) }
      : set
  );
  return { ...state, data: updatedData };
}

function attributeAdd({
  state,
  type = "sentiment",
  attributeObj,
  selectedSideTab,
}) {
  state.data.forEach((set) => {
    if (selectedSideTab == set.id) {
      if(!set[type]){
         set[type]=[];

      }
      set[type].push(attributeObj);
    }
  });

  return { ...state };
}

function attributeUpdate({ state, attributeObj }) {
  let type = attributeObj.type;
  let id = attributeObj.id;
  let selectedTab = attributeObj.setting_Id;

  state.data.forEach((set) => {
    if (selectedTab == set.id) {
      set[type] = set[type].map((attribute) => {
        if (attribute.id === id) {
          return { ...attribute, ...attributeObj };
        }
        return attribute;
      });
    }
  });

  return { ...state };
}
